<template lang="pug">
md-table-card.card
  form(novalidate='', @submit.stop.prevent='search')
    .filters
      md-layout.search(md-align='end')
        md-layout.searchContainer(md-flex='33', md-align='end')
          md-layout
            md-input-container
              label Search
              md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
          md-layout(md-flex='15', v-if='searchText != ""')
            md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanSearchText')
              md-icon.icon(md-iconset="fa fa-trash-alt")
          md-layout(md-flex='10')
            md-button.md-icon-button.btn(type='submit', :disabled='loading')
              md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(v-if='loading', :loading='loading', :size='45')
  div(v-if="hasPlaylistsToDisplay")
    div.titleLine.styleRow
      p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements Status
      p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements
    div.styleRow.colorHover(v-for='playlist in playlists', :key='playlist._id')
      div.rowElements {{playlist.name}}
      div.rowElements(v-if="playlist.status === 'public'") live
      div.rowElements(v-else) {{ playlist.status }}
      div.rowElements {{ playlist.lastUpdated | moment('from') }}
      div.rowElements.deleteLoader(v-if="playlist.loadingDelete")
        stitch-loader(:loading='playlist.loadingDelete', :size='25')
      div.rowElements(v-else)
        md-button.md-icon-button.md-raised.btn#edit-playlist(@click='editPlaylist(playlist._id)')
          md-icon.icon(md-iconset="fa fa-pencil-alt")
        md-button.md-icon-button.md-raised.btn#delete-playlist(@click='deletePlaylist(playlist._id, playlist.name)')
          md-icon.icon(md-iconset="fa fa-trash-alt")

  md-table-pagination(
    v-show='hasPlaylistsToDisplay',
    :md-size='currentPagination.size',
    :md-total='totalPlaylists',
    :md-page='currentPagination.page',
    md-label='Playlists',
    md-separator='of',
    :md-page-options='[10, 25, 50, 100]',
    @pagination='onPageChanged'
  )

  div#no-results(v-if='hasNoResults')
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
      | No items to show
</template>

<script>
import playlistService from '../../services/playlistService';
import stitchLoader from '../../shared-components/Loader';

export default {
  components: {
    stitchLoader
  },
  data() {
    return {
      playlists: [],
      totalPlaylists: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'lastUpdated',
        type: 'desc'
      },
      searchText: ''
    };
  },
  computed: {
    searchParams() {
      const params = {
        offset: (this.searchText || this.currentPagination.page == 1) ? 0 : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPaginationPlaylist") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalPlaylists != null && params.offset >= this.totalPlaylists) {
        params.offset = 0
      }

      return params;
    },
    hasPlaylistsToDisplay() {
      return !this.loading && this.playlists.length > 0;
    },
    hasNoResults() {
      return !this.loading && this.playlists.length === 0;
    }
  },
  methods: {
    showAlertToast(text, icon) {
      this.$swal({
        text: text,
        position: 'bottom-left',
        icon: icon,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      })
    },
    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPagePlaylist", paginationParams.page);
      this.$session.set("limitPaginationPlaylist", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },
    search() {
      this.loading = true;
      playlistService.getList(this.searchParams)
        .then((response) => {
          this.playlists = response.data.playlists;
          this.totalPlaylists = response.data.total;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of playlists', error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    editPlaylist(playlistId) {
      this.$router.push({
        name: 'EditPlaylist',
        params: {
          id: playlistId
        }
      });
    },
    async deletePlaylist(playlistId, playlistName) {
      const playlist = this.playlists.find(({ _id }) => _id === playlistId);
      if (playlist) {
        this.$set(playlist, "loadingDelete", true);
      }
      const distrosResponse = await playlistService.getAssociatedDistributions(playlistId);
      const associatedDistributions = distrosResponse.data.distributions;
      this.$set(playlist, 'loadingDelete', false);
      let distributionsInfo = '';
        associatedDistributions.forEach((distribution) => {
          distributionsInfo += `<p><a target="_blank", rel="noopener noreferrer", href='/distribution/${distribution._id}/edit'> ${distribution.name}</a></p>`;
        });
      const html = associatedDistributions.length > 0
        ? `<p><strong>Name</strong>: ${playlistName}</p> <p style="color: darkorange;"> This playlist is associated with the following distribution(s). Deleting this playlist will result in the associated distribution(s) losing their content. Are you sure you want to proceed?</p> ${distributionsInfo}` 
        : `<p><strong>Name</strong>: ${playlistName}</p>`
        try {
            const res = await this.$swal.fire({
              title: 'Delete playlist?',
              html: html,
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete',
              cancelButtonText: 'No',
            });
            if (res.isConfirmed) {
              this.loading = true;
              await playlistService.delete(playlistId)
              await this.search();
              this.showAlertToast('Playlist deleted successfully', 'success');
            }

          } catch (error) {
            this.showAlertToast('Playlist could not be deleted. Please, try again later', 'error');
          } finally {
            this.loading = false;
          }
    },
    cleanSearchText() {
      this.searchText = '';
      this.search()
    },
  },
  mounted() {
    this.$session.set("limitPagination", this.currentPagination.size);
    this.$session.set("limitPaginationDomains", this.currentPagination.size);
    this.$session.set("limitPaginationDistributions", this.currentPagination.size);

    if (this.$session.get("iWasInPagePlaylist") === undefined) {
      this.$session.set("iWasInPagePlaylist", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPagePlaylist');
    if(this.$session.get("limitPaginationPlaylist") !== undefined){
      this.currentPagination.size = this.$session.get("limitPaginationPlaylist");
    }
    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.search();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}

.search {
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 20px;
  }
}

.filters {
  padding: 2px 20px;
}

.searchContainer {
  flex: none;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

#no-results {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover {
  cursor: pointer;
  color: #4ea9dd;
}

.rowElements.deleteLoader{
  padding-top: 0;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/playlist/PlaylistTable.vue